import React from 'react';
import { differentiators } from '../data/electrical';
export function DifferentiatorSection() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-33" data-mp="3j4h1ns3oaf6f">
      <div className="mx-auto max-w-4xl" data-id="element-34" data-mp="3j1uu3sgs7zo7">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-35" data-mp="3558w8hgx2ats">
          THIS ISN’T JUST ANOTHER ELECTRICAL EBOOK
        </h2>
        <p className="mt-0.5 text-center font-display text-base uppercase text-navy/70 sm:text-2xl" data-id="element-36" data-mp="3a5n7s9hq82wk">
          IT’S A COMPLETE VISUAL DIAGNOSTIC SYSTEM.
        </p>

        <ul className="mt-2 grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-37" data-mp="306eeliuoqsb9">
          {differentiators.map(item => <li key={item.title} className="rounded-lg border border-navy/10 bg-white p-2.5 shadow-sm" data-id="element-38" data-mp="2mfj1tvh2fr2e">
              <p className="font-head text-[13px] font-extrabold uppercase leading-tight text-navy" data-id="element-39" data-mp="2cg21zuohw7ec">
                <span aria-hidden="true" data-id="element-40" data-mp="2hell7nbpf530">{item.emoji}</span> {item.title}
              </p>
              <p className="mt-1 text-[13px] font-medium leading-snug text-carbon/80" data-id="element-41" data-mp="15h4cmmdgugdg">
                {item.body}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}